import React from 'react';
import { useTranslation } from 'react-i18next';

import scss from './UserTable.module.scss';

const EnableUserLabel = ({ name, enabled }) => {
  const { t } = useTranslation('userManagement');

  return (
    <span>
      {enabled ? t('doYouReallyWantToDisable') : t('doYouReallyWantToEnable')}:{' '}
      <span className={scss.stressedName}>{name}</span>?
    </span>
  );
};

export default EnableUserLabel;
